<section class="pt-3">
  <screen-support></screen-support>  
</section>


<section class="sfe-safe pt-5 sfe-welcome">
  <h1 class="sfe-welcome-head">Dashboard</h1>
  <p>You're a step closer to building your business! Take an assessment or build your business plan.</p>
  <button class="sfe-capitalize sfe-button-round sfe-button-rblue" mat-raised-button  routerLink="/action-plan"  >Action Plan</button>
</section>

<nav aria-label="breadcrumb" class="pt-5 ">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
  </ol>
</nav> 


<section class="sfe-safe pt-3">
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12 sfe-col-spacer">
      <mat-card> 
        <mat-card-header>
          <div mat-card-avatar class="icon-calc"><mat-icon class="icon-calc">calculate</mat-icon></div>
          <mat-card-title class="sfe-card-header">
            Revenue Calculator
           </mat-card-title>
        </mat-card-header>
       
        <mat-card-content class="sfe-card-text">
         <p>We are working on a super awesome revenue calculator. It isn't quite right yet so we disabled the button.
           As soon as it becomes available, it will be enabled for you to use and enjoy!
        </p> 
          <button class="sfe-capitalize sfe-button-round sfe-button-rblue" mat-raised-button  disabled  >Revenue Calculator</button>
        </mat-card-content> 
      </mat-card>
    </div>
  
    
    <div class="col-lg-6 col-md-6 col-sm-12 sfe-col-spacer">
      <mat-card> 
        <mat-card-header>
          <div mat-card-avatar class="icon-calc"><mat-icon class="icon-calc">auto_graph</mat-icon></div>
          <mat-card-title class="sfe-card-header">
            Help us Improve the System!
           </mat-card-title>
        </mat-card-header>
       
        <mat-card-content class="sfe-card-text">
         <p>Our application can only be better with your feedback. We value your time and would love if you could just take a couple minutes from your
           schedule to tell us how we can make things better for you. 
        </p> 
          <button class="sfe-capitalize sfe-button-round sfe-button-rblue" mat-raised-button href="https://docs.google.com/forms/d/e/1FAIpQLSfJN-WKAh1VYvLt1SN05uDZqa_Ihm5N8dh3QRuBZjSB0C4rBw/viewform" 
           target="_blank"  rel="noopener noreferrer">Feedback</button>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</section>

<div class="pt-5"></div>

<section class="section-button white-bg sfe-safe">

  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div class=" sfe-top-section ">
        <h1 class="section-label">Business Assessment Results</h1>
        <div class="section-button-row">
          <button mat-fab color="primary" aria-label="New Business Assessment" routerLink="/business-assessment" *ngIf="hideWhenNoAssessment" disabled="disabled"> <mat-icon>add</mat-icon></button>
        </div>     
      </div>
      
       <!-- No data shows when their is no data available -->
       <div class="no-data" *ngIf="!dataBusiness?.length">                
        <p class="nodata-msg section-label">Oh no! Doesn't seem you've taken a Business Assessment yet! Take an assessment to see your results.</p>
       <div class="section-button-row">
          <button mat-fab color="primary" routerLink="/business-assessment"><mat-icon>add </mat-icon></button>
       </div>
       
        <p>Having Problems? <a routerLink="/troubleshoot">Troubleshoot</a></p>
      </div>

      <div class="table-responsive pt-3" *ngIf="dataBusiness?.length">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th scope="col">Business name</th>
              <th scope="col">Owner Name</th>
              <th scope="col">Results</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let assessment of dataBusiness |  paginate: { itemsPerPage: 7, currentPage: p }; let i = index;">
              <td>{{assessment.busiName}}</td>
              <td>{{assessment.busiFirstName}} {{assessment.busiLastName}}</td>
              <td>
                  <button color="primary" mat-button  id="AssessmentResults" routerLink="/business-assessment-results/{{assessment.key}}">RESULTS</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls (pageChange)="p = $event" autoHide="true" responsive="true"></pagination-controls>
    </div>
  <!--  <div class="col-lg-6 col-md-6 col-sm-12">
      <div class=" sfe-top-section ">
        <h1 class="section-label">Model Assessment Results</h1>
        <div class="section-button-row">
          <button mat-fab color="primary" aria-label="New Model Assessment" routerLink="/model-assessment" *ngIf="hideWhenNoAssessment" disabled="disabled"> <mat-icon>add</mat-icon></button>
        </div>     
      </div>
      
       <!-- No data shows when their is no data available 
       <div class="no-data" *ngIf="!data?.length">                
        <p class="nodata-msg section-label">Oh no! Doesn't seem you've taken a Model Assessment yet! Take an assessment to see your results.</p>
       <div class="section-button-row">
          <button mat-fab color="primary" routerLink="/model-assessment"><mat-icon>add </mat-icon></button>
       </div>
       
        <p>Having Problems? <a routerLink="/troubleshoot">Troubleshoot</a></p>
      </div>

      <div class="table-responsive pt-3" *ngIf="data?.length">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th scope="col">Business name</th>
              <th scope="col">Owner Name</th>
              <th scope="col">Results</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let assessment of data |  paginate: { itemsPerPage: 7, currentPage: p }; let i = index;">
              <td>{{assessment.busiName}}</td>
              <td>{{assessment.busiFirstName}} {{assessment.busiLastName}}</td>
              <td>
                  <button color="primary" mat-button  id="AssessmentResults" routerLink="/model-results/{{assessment.key}}">RESULTS</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-controls (pageChange)="p = $event" autoHide="true" responsive="true"></pagination-controls>
    </div>

    <div class="col-lg-6 col-md-6 col-sm-12">
      <div class=" sfe-top-section ">
        <h1 class="section-label"> Operating Assessment Results</h1>
        <div class="section-button-row">
          <button mat-fab color="primary" aria-label="New Model Assessment" routerLink="/operating-assessment" *ngIf="hideWhenNoOperatingAssessment" disabled="disabled"> <mat-icon>add</mat-icon></button>
        </div>     
      </div>
      <!-- No data shows when their is no data available 
      <div class="no-data" *ngIf="!dataOperating?.length">                
       <p class="nodata-msg section-label">Oh no! Doesn't seem you've taken an Operating Assessment yet! Take an assessment to see your results.</p>
      <div class="section-button-row">
         <button mat-fab color="primary" routerLink="/operating-assessment"><mat-icon>add </mat-icon></button>
      </div>
      
       <p>Having Problems? <a routerLink="/troubleshoot">Troubleshoot</a></p>
     </div>
     <div class="table-responsive pt-3" *ngIf="dataOperating?.length">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th scope="col">Business name</th>
            <th scope="col">Results</th>
          </tr>
        </thead>
        <tbody>
          <!-- *ngFor loop iterates over Student array and fetch the student's data -->
          <!-- paginate pipe will add pagination in student's list, it won't show if items are less then 7 

          <tr *ngFor="let assessmentOp of dataOperating |  paginate: { itemsPerPage: 7, currentPage: p }; let i = index;">
            <td>{{assessmentOp.busiName}}</td>
            <td>
                <button mat-button color="primary" id="AssessmentResults" routerLink="/operating-results/{{assessmentOp.key}}">RESULTS</button> 
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination-controls (pageChange)="p = $event" autoHide="true" responsive="true"></pagination-controls>

     </div>-->
  </div>
</section>

